import { company } from '@/data/company';
import { ContactForm } from '@/components/common/ContactForm';
import { MotionReveal } from '@/components/common/MotionReveal';

export function ContactSection() {
  return (
    <section
      id="home-kontakt"
      className="scroll-mt-20 bg-footer py-20 text-footer-text sm:py-26 lg:py-34"
    >
      <div className="site-container">
        <MotionReveal className="grid gap-6 border-b border-white/14 pb-10 lg:grid-cols-[0.88fr_0.42fr] lg:items-end lg:justify-between lg:gap-24 lg:pb-14">
          <h2 className="max-w-4xl text-balance text-4xl font-semibold leading-[1.06] tracking-[-0.055em] text-footer-text sm:text-5xl lg:text-[4rem]">
            Imate projekat koji treba organizovati i završiti?
          </h2>
          <p className="max-w-md text-base leading-7 text-footer-muted">
            Pošaljite osnovne informacije. Javićemo se da proverimo obim, rok i
            odgovarajući prvi korak.
          </p>
        </MotionReveal>

        <div className="mt-11 grid gap-12 lg:mt-14 lg:grid-cols-[0.48fr_1.12fr] lg:gap-20">
          <MotionReveal>
            <p className="text-sm font-medium text-footer-muted">
              Direktan kontakt
            </p>
            <div className="mt-5 space-y-2 text-sm">
              <a
                className="animated-link block w-fit text-footer-text transition-colors hover:text-primary"
                href={`mailto:${company.email}`}
              >
                {company.email}
              </a>
              <a
                className="animated-link block w-fit text-footer-text transition-colors hover:text-primary"
                href={`tel:${company.phoneHref}`}
              >
                {company.phone}
              </a>
              <p className="pt-3 text-footer-muted">{company.workingHours}</p>
            </div>
          </MotionReveal>

          <MotionReveal delay={0.05}>
            <ContactForm variant="compact" tone="dark" />
          </MotionReveal>
        </div>
      </div>
    </section>
  );
}
